var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('custom-multi-search', {
    attrs: {
      "searchTypes": _vm.searchTypes,
      "searchItems": _vm.searchItems,
      "defaultSearchType": {
        param: 'quickSearch',
        text: 'Quick search'
      },
      "showOperatorDropdown": "",
      "operator": _vm.operator,
      "readonly": _vm.readonly && !_vm.copyMode
    },
    on: {
      "updated": (search, operator) => _vm.$emit('updated', search, operator)
    }
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };